import { register, requestOtp, store, storePhone, uploadPhoto, verifyOtp } from '@/api/register';
import { defineStore } from 'pinia';


export const useRegistrationStore = defineStore('registrationStore', {
    state: () => ({
        newRegistration: {
            step: 1,
            phone_number: null,
            fullname: null,
            wilaya: null,
            commune: null,
            address: null,
            geolocation: null,
            poster: {
                files: [],
                previews: [],
                paths: [],
                error: {
                    hasError: false,
                    message: ''
                }
            },
            shop: {
                files: [],
                previews: [],
                paths: [],
                error: {
                    hasError: false,
                    message: ''
                }
            },
            type: null,
            error: {
                hasError: false,
                message: ""
            }
        },
        step: 1,
        phone: null,
        user_exists: false,
        pos: null,
        token: null,
        registration: {
            phone_number: null,
            fullname: null,
            wilaya: null,
            commune: null,
            address: null,

            geolocation: null,
            poster: {
                files: [],
                previews: [],
                paths: [],
                error: {
                    hasError: false,
                    message: ''
                }
            },
            shop: {
                files: [],
                previews: [],
                paths: [],
                error: {
                    hasError: false,
                    message: ''
                }
            },
            type: null,
            giftyPassword: null,
            error: {
                hasError: false,
                message: ""
            }
        },
    }),
    actions: {
        setPos(data) {
            this.pos = data;
        },
        clearPos() {
            this.pos = null
        },

        goToVerification() {
            this.step++;
        },
        goToForm() {
            this.step++;
        },
        async submitRegistrationData(data) {
            try {

                Object.assign(this.registration, {
                    fullname: (!this.user_exists || this.registration.fullname == null) ? data.fullname : this.registration.fullname,
                    wilaya: (!this.user_exists || this.registration.wilaya == null) ? data.wilaya : this.registration.wilaya,
                    commune: (!this.user_exists || this.registration.commune == null) ? data.commune : this.registration.commune,
                    address: (!this.user_exists || this.registration.address == null) ? data.address : this.registration.address,
                    giftyPassword: !this.user_exists ? data.giftyPassword : null,
                    type: (!this.user_exists || this.registration.type == null) ? data.type : this.registration.type,
                });




                const uploadResult = await this.handleFileUploads();
                console.log('uploadResult :>> ', uploadResult);
                if (!uploadResult.success) {
                    console.error('File upload failed:', uploadResult.details);
                    this.registration.poster.error = { hasError: true, message: uploadResult.message };
                    this.registration.shop.error = { hasError: true, message: uploadResult.message };
                    return uploadResult;
                } else {



                    this.registration.poster.paths = uploadResult.posterPaths;
                    this.registration.shop.paths = uploadResult.shopPaths;

                    const payload = {
                        phone_number: this.phone,
                        full_name: this.registration.fullname,
                        address: this.registration.address,
                        wilaya_id: this.registration.wilaya?.id,
                        commune_id: this.registration.commune.id,
                        salepoint_type_id: this.registration.type.id,
                        latitude: String(this.registration.geolocation?.latitude ?? ''),
                        longitude: String(this.registration.geolocation?.longitude ?? ''),
                        gifty_stickers_photos: this.registration.poster.paths,
                        store_photos: this.registration.shop.paths,
                        password: this.registration.giftyPassword,
                        token: this.token,

                    };


                    try {
                        const response = await register(payload);


                        if (response.status == 200) {
                            this.step++;
                            return { success: true, message: 'registration_success' };
                        } else {
                            return {
                                success: false,
                                code: 'REGISTRATION_FAILED',
                                message: 'registration_failed',
                                details: response.data?.message || 'API responded with failure.',
                            };
                        }
                    } catch (error) {
                        console.error('Registration request failed:', error);
                        return {
                            success: false,
                            code: 'REGISTRATION_API_ERROR',
                            message: 'registration_failed',
                            details: error.message || 'API connection failed.',
                        };
                    }
                }
            } catch (error) {
                console.error('Unexpected error during registration:', error);
                return {
                    success: false,
                    code: 'SERVER_ERROR',
                    message: 'server_connection_error',
                    details: error.message || 'Unknown server error.',
                };
            }
        },

        async sendOtpRequest(phone) {

            this.phone = phone;

            try {
                let response = await requestOtp(phone);
                console.log('Code OTP :>> ', response.data.data.code);
                this.token = response.data.data.token;
                return response.data;

            } catch (error) {
                console.log('error :>> ', error);

                if (error.response && error.response.status === 429) {
                    return {
                        success: false,
                        message: "phone_rate_limit_exceeded",
                    };
                } else {
                    return {
                        success: false,

                    };
                }
            }
        },
        async checkOtpRequest(code) {

            let payload = {
                code,
                token: this.token
            };

            try {
                let response = await verifyOtp(payload);
                console.log('response :>> ', response);

                if (response.data.success) {
                    this.user_exists = response.data.data.user_exists;
                    if (this.user_exists) {
                        this.registration.fullname = response.data.data.user.name;
                        this.registration.type = response.data.data.user.role;
                        this.registration.wilaya = response.data.data.user.wilaya_id;
                        this.registration.commune = response.data.data.user.commune_id;
                    }
                    this.token = response.data.data.token;
                    localStorage.setItem("auth_token", this.token);
                }

                return response.data;
            } catch (error) {
                console.log('error :>> ', error);
                return {
                    success: false,
                    code: 'UPLOAD_FAILED',
                    message: 'phone_verification_failed',
                };
            }
        },
        async handleFileUploads() {
            const uploadGroup = async (files, groupName) => {




                if (!files?.length) return [];

                const uploads = files.map(async (fileWrapper) => {
                    try {

                        const response = await uploadPhoto(fileWrapper);

                        console.log('response :>> ', response);
                        if (response.data?.success) {


                            return response.data.data;
                        } else {
                            throw new Error('Upload response unsuccessful');
                        }
                    } catch (error) {
                        console.error(`Error uploading ${groupName}:`, error);
                        throw new Error(`${groupName}_upload_failed`);
                    }
                });

                return await Promise.all(uploads);
            };

            try {
                const [posterPaths, shopPaths] = await Promise.all([
                    uploadGroup(this.registration.poster.files, 'poster'),
                    uploadGroup(this.registration.shop.files, 'shop'),
                ]);



                return {
                    success: true,
                    posterPaths: posterPaths.length > 0 ? posterPaths : ["test_path1", "test_path2"],
                    shopPaths: shopPaths.length > 0 ? shopPaths : ["test_shoppath1", "test_shoppath2"],
                };
            } catch (error) {
                console.warn('File upload process failed:', error);
                return {
                    success: false,
                    code: 'UPLOAD_FAILED',
                    message: 'upload_failed',
                    details: error.message || 'One or more files failed to upload.',
                    posterPaths: [],
                    shopPaths: [],
                };
            }
        },
        async sendPhoneForRegistration(phone) {
            this.phone = phone;

            try {
                let response = await storePhone(phone);

                console.log('response :>> ', response);
                this.updatePosData(response.data.registration);
                this.user_exists = response.data.user_exists;
                return response.data;

            } catch (error) {
                console.log('error :>> ', error);

                if (error.response && error.response.status === 429) {
                    return {
                        success: false,
                        message: "phone_rate_limit_exceeded",
                    };
                } else {
                    return {
                        success: false,

                    };
                }
            }
        },
        updatePosData(data) {

            console.log('data :>> ', data);

            this.registration.phone_number = data.phone_number ?? null;
            this.registration.fullname = data.full_name ?? null;
            this.registration.wilaya = data.wilaya ?? null;
            this.registration.commune = data.commune ?? null;
            this.registration.address = data.address ?? null;
            this.registration.geolocation = data.geolocation ?? null;
            this.registration.type = data.type ?? null;


            if (data.poster) {
                this.registration.poster.paths = data.poster.paths ?? this.registration.poster.paths;

                if (data.poster.error) {
                    this.registration.poster.error.hasError = data.poster.error.hasError ?? this.registration.poster.error.hasError;
                    this.registration.poster.error.message = data.poster.error.message ?? this.registration.poster.error.message;
                }
            }

            if (data.shop) {
                this.registration.shop.paths = data.shop.paths ?? this.registration.shop.paths;

                if (data.shop.error) {
                    this.registration.shop.error.hasError = data.shop.error.hasError ?? this.registration.shop.error.hasError;
                    this.registration.shop.error.message = data.shop.error.message ?? this.registration.shop.error.message;
                }
            }

            if (data.error) {
                this.registration.error.hasError = data.error.hasError ?? this.registration.error.hasError;
                this.registration.error.message = data.error.message ?? this.registration.error.message;
            }
        },

        async newRegisterPos(data) {
            try {
                const response = await store(data);

                const result = response?.data ?? response;

                return {
                    success: result?.success ?? false,
                    message: result?.message ?? "unknown_error",
                    data: result?.data ?? null,
                };
            } catch (error) {
                console.error("newRegisterPos error:", error);

                return {
                    success: false,
                    message: "server_connection_error",
                    data: null,
                };
            }

        }

    }


})